module.exports = __webpack_public_path__ + "static/media/NTPC.95d55de3.txt";